import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { tasksId } from "../../../types/activityTasks";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { imgInstructionTeam2 } from "../../../assets/imgIntruction/tema2";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogInitial: 1,
	panelActivity: 2,
	dialogThree: 3,
	panelInstruction1: 4,
	panelInstruction2: 5,
	gameClean: 6,
	win: 7
};

export const Team2SubtopicOneActivityTwo = () => {
	const navigator = useNavigate();
	const dispatch = useDispatch()
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema2.activities.subtema1], 2);

	useEffect(() => {
		if (loaded) {
			console.log('tema 2 sub 1 act 2');
			ObserverEmitter.emit(EVENTS.team2.subtopicOne.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub01.sub1_act2_a01T2)
	})

	ObserverEmitter.on(EVENTS.team2.subtopicOne.activityTwo.finishCleanAct2, () => {
		setUiToShow(steps.win)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2, steps.gameClean].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.team2.subtopicOne.initScene, 2);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.gameClean && (
				<>
					<BarStatusActivies activities={tasksList} />
				</>
			)}

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 2: Operación de Roller: Limpieza" />
					<DialogBarNew
						dialog={"Han llegado muchos clientes, es momento de revisar la charola de verduras, los panes y salchichas."}
						percentage={"10%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivity);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.panelActivity && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1: Operación de Roller"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub01.sub1_act2_a02T2)
							ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityTwo.moveInClearContainer)
							setUiToShow(steps.dialogThree);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<DialogBarNew
					dialog={
						"Regresa el orden a la zona dando clic en los lugares donde notes que esto sea necesario. Pon atención a la Tabla de exhibición variable y al reloj."
					}
					percentage={"100%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						setUiToShow(steps.panelInstruction1);
					}}
				></DialogBarNew>
			)}

			{uiToShow === steps.panelInstruction1 && (
				<>
					<PanelInstrucionHands
						text="Toca y arrastra con tu dedo para girar la vista."
						action={() => {
							setUiToShow(steps.panelInstruction2);
						}}
						img={imgInstructionTeam2.team2_sub1_act_2_01}
					/>
				</>
			)}

			{uiToShow === steps.panelInstruction2 && (
				<>
					<PanelInstrucionHands
						text="Toca encima los objetos para limpiar las manchas."
						action={() => {
							ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityTwo.onActivityClean)
							ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityTwo.visibleFasFood)
							setUiToShow(steps.gameClean);
						}}
						img={imgInstructionTeam2.team2_sub1_act_2_02}
					/>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="La limpieza siempre debe ser nuestra carta de presentación."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityTwo.visibleFasFood, 1)
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 10,
									subtema: tasksId.tema2.activities.subtema1,
								})
							);
							navigator("/home2/tema2/subtema1/activityThree");
						}}
					/>
				</>
			)}

		</>
	);
};
